module.exports = __webpack_public_path__ + "static/media/cj.9d81ee72.svg";